import { BaseAsyncValue } from '../../../shared/models/async-value';
import { Observable } from 'rxjs';
import { getOneClickSelectedOrder } from '../../selectors/one-click-orders.selector';
import { map, filter } from 'rxjs/operators';

export class OneClickPlantsProvider extends BaseAsyncValue<string> {
  getValue(): Observable<string> {
    return this.store.select(getOneClickSelectedOrder).pipe(
      filter(order => !!order && !!order.items && !!order.items.length),
      map(order => order.items[0]),
      map(item => {
        return `${item.shippingSource.shippingSourceDesc}`;
      }),
    );
  }
}
